export type EventStatTile = {
  label: string
  value: number
  /** Unique users behind `value`, shown under it. */
  users?: number
  /** Shows `users` as a share of this many users. */
  ofUsers?: number
}

const percent = (part: number, whole: number): string => (whole > 0 ? ` · ${Math.round((part / whole) * 100)}%` : '')

const EventStatTiles = ({ tiles }: { tiles: EventStatTile[] }) => (
  <div className="event-journey-tiles">
    {tiles.map(tile => (
      <div key={tile.label} className="event-journey-tile">
        <span className="event-journey-tile__label">{tile.label}</span>
        <span className="event-journey-tile__value">{tile.value.toLocaleString()}</span>
        {tile.users !== undefined && (
          <span className="event-journey-tile__sub">
            {tile.users.toLocaleString()} users
            {tile.ofUsers !== undefined ? percent(tile.users, tile.ofUsers) : ''}
          </span>
        )}
      </div>
    ))}
  </div>
)

export default EventStatTiles
